import "./AuthorGuidelines.scss";
import { manuscriptGuidelines, referenceFormat } from './authorGuidelinesData';

const AuthorGuidelines = () => {
    return (
        <section className="authorGuidelinesMainContainer">
            <article className="contentParent">
                {manuscriptGuidelines.map((script, index) => (
                    <>
                        <div key={index}>
                            <p>{script.intro}</p>
                        </div>
                        <ul>
                            {script.points.map((point, index) => (
                                <li key={index}>
                                    <strong>{point.category}</strong>
                                    {point.description}
                                </li>
                            ))}
                        </ul>
                    </>
                ))}
            </article>
            <article className="secondSection">
                {referenceFormat.map((format, index) => (
                    <div key={index} style={{ lineHeight: "clamp(1.7575rem, 2.73125vw, 3.2775rem)" }}>
                        <h3>{format.category}</h3>
                        {format.points.map((point, index) => (
                            <p key={index}>
                                <strong>{point.title}</strong>
                                {point.description}
                            </p>
                        ))}
                    </div>
                ))}
            </article>
        </section>
    )
}

export default AuthorGuidelines
